// extracted by mini-css-extract-plugin
export default {"about":"About_about__rLCow","a":"About_a__-LdbD","b":"About_b__iuRIK","c":"About_c__2TzNM","d":"About_d__755pJ","f":"About_f__JNvRT","g":"About_g__gCfLe"};